export default "__VITE_PUBLIC_ASSET__a564cc01__"